import { Component, inject, Input, Output, EventEmitter, computed } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SidenavDrawerService } from '../../shared/services/sidenav-drawer.service';
import { CommonModule } from '@angular/common';
import {
  StepDraftLesson,
  StepHome,
  StepHomeOpenSearch,
  StepPillsKnowledge,
  StepQuestionForm,
  StepSimilarProject,
  getLessonsLearningSteps,
} from '../../shared/constants/steps-boarding.contasts';
import { OnBoardingService } from '../../shared/services/on-boarding.service';
import { ActivatedRoute } from '@angular/router';
import { CustomDriveStep } from '../../shared/models/customDriverSteps';
import { LessonsProjectService } from '../../shared/services/lessons-project.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, MatCardModule, TranslateModule, MatIconModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() active = '';
  @Output() activeChange = new EventEmitter<string>();

  private sidenavDrawerService = inject(SidenavDrawerService);
  private onBoardingService = inject(OnBoardingService);
  private activatedRoute = inject(ActivatedRoute);
  private projectsService = inject(LessonsProjectService);
  private onBoardinbgKey = 'Footer-onboarding';
  isVisibleTour = true;
  projectsUnderPreparation = computed(() => this.projectsService.projectsUnderPreparation());
  projectsExecution = computed(() => this.projectsService.projectsExecution());

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const pillType = params.get('pillType');
      if (pillType) {
        this.isVisibleTour = pillType === 'SimilarProjects';
      } else {
        this.isVisibleTour = true;
      }
    });
  }

  async openFaq() {
    await this.onBoardingService.closeBeforeNavigation();
    this.activeChange.emit('faq');
    const { FaqsDrawerComponent } =
      await import('../../shared/components/faqs/faqs-drawer.component');
    document.body.classList.add('footer-drawer-open');
    await this.sidenavDrawerService.open(FaqsDrawerComponent);
  }

  async openTerms() {
    await this.onBoardingService.closeBeforeNavigation();
    this.activeChange.emit('terms');
    const { TermsAndConditionsComponent } =
      await import('../../shared/components/terms-and-conditions/terms-and-conditions.component');
    document.body.classList.add('footer-drawer-open');
    await this.sidenavDrawerService.open(TermsAndConditionsComponent);
  }

  private filterOnboardingSteps(): CustomDriveStep[] {
    const hasPreparation = this.projectsUnderPreparation().length > 0;
    const hasExecution = this.projectsExecution().length > 0;
    const noProjectsStepIds = [
      '#step-home-sidebar',
      '#step-home-search',
      '#step-home-grouping',
      '#step-onbarding',
    ];
    const preparationStepIds = [
      '#step1',
      '#button_similar_dialog',
      '#button_lesson_dialog',
      '#button_literature_dialog',
      '#button_document_dialog',
    ];
    const executionStepIds = ['#step2', '#button_created_lesson_dialog'];

    if (!hasPreparation && !hasExecution) {
      return StepHome.filter(step => noProjectsStepIds.includes(step.element));
    }

    return StepHome.filter(step => {
      if (!hasPreparation && preparationStepIds.includes(step.element)) {
        return false;
      }
      if (!hasExecution && executionStepIds.includes(step.element)) {
        return false;
      }
      return true;
    });
  }

  startOnboarding(): void {
    let steps: CustomDriveStep[] | undefined = undefined;

    switch (window.location.pathname.split('/')[1]) {
      case 'knowledge':
        steps = StepPillsKnowledge.filter(s => {
          if (s.element === '#preparation-header') {
            return !!document.querySelector('#preparation-header');
          }
          if (s.element === '#execution-header') {
            return !!document.querySelector('#execution-header');
          }
          return true;
        });
        break;
      case 'open-pill':
        steps = StepSimilarProject;
        break;
      case 'lessons-learning':
        steps = getLessonsLearningSteps(
          decodeURIComponent(window.location.pathname.split('/')[2] ?? '') === 'Cross-cutting',
        );
        break;
      case 'home':
        steps = this.filterOnboardingSteps();
        break;
    }
    const isOpenSideBarSearch =
      this.activatedRoute.snapshot.queryParamMap.get('isOpenSideBarSearch');
    if (isOpenSideBarSearch === 'true') {
      steps = StepHomeOpenSearch;
    } else if (sessionStorage.getItem('lessonFlow') === 'true') {
      steps = StepDraftLesson;
    } else if (sessionStorage.getItem('formflow') === 'true') {
      steps = StepQuestionForm;
    }

    if (steps && steps.length > 0) {
      void this.onBoardingService.startTour(steps, this.onBoardinbgKey, true);
    } else {
      console.warn('No onboarding steps defined for this route.');
    }
  }
}
